import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 参考資料ファイル情報取得
 */
@Injectable()
export class GetReferenceImageOutputService extends PlessJsonResponderSub<any> {

  private imageIdList: string[] = [];

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetReferenceImageOutputService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: this.imageIdList.length === 0 ?
        {} : {
          ImageIDList: {
            combination: this.imageIdList.map(_ => {
              return {
                parameter: {
                  ImageID: _
                }
              }
            })
          }
        }
    });
  }

  /**
   * API呼び出し
   *
   * @param {string[]} [imageIdList]
   * @param {Function} [successFunc=null]
   * @memberof GetReferenceImageOutputService
   */
  execute(imageIdList: string[], successFunc: Function): void {
    this.imageIdList = imageIdList;
    this.successFunc = successFunc;
    this.send('KYMW17GetReferenceImageOutput', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetReferenceImageOutputService
   */
  success(data: any): void {
    if (this.successFunc !== null && data !== null) {
      this.successFunc(data.FileUrl);
    }
  }
}
